// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"DefaultButton_defaultButton__3xYp1","selected":"DefaultButton_selected__dcnkT","disabled":"DefaultButton_disabled__3jgs1"};